<template>
  <div>
    <el-date-picker
      v-model="monthsQuery"
      type="month"
      :clearable="false"
      :value-format="'yyyy-MM-dd HH:mm:ss'"
      @change="onChangeMonths"
      :picker-options="pickerOptions"
    >
    </el-date-picker>
    <div class="scrollBar">
      <el-timeline v-if="activities.length > 0">
        <el-timeline-item
          v-for="(item, index) in activities"
          :key="index"
          color="#409EFF"
          size="normal"
          :timestamp="item.msgTime"
        >
          {{ item.time }}
          <div class="record_item">
            <div>
              <span>{{ item.msgTitle }}</span>
              <span>{{ $t("lang.操作人") }}:{{ item.operatorInfo }}</span>
            </div>
            <p>{{ item.msgValue }}</p>
          </div>
        </el-timeline-item>
      </el-timeline>
      <div v-else class="noData">{{ $t("lang.暂无数据") }}</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      monthsQuery: moment().format("YYYY-MM-01 00:00:00"),
      activities: [],
      pointId: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      operationRecord: "ZD_OperationRecord",
    }),
    async getOperationRecord(pointId, deviceType) {
      this.pointId = pointId;
      let res = await this.operationRecord({
        pointId: pointId,
        queryTime: this.monthsQuery,
      });
      if (res.success !== 1) return;
      res.listitem.forEach((item) => {
        item.time = moment(item.msgTime).format("HH:mm");
        item.msgTime = moment(item.msgTime).format("YYYY-MM-DD");
      });
      this.activities = res.listitem;
    },
    onChangeMonths() {
      this.getOperationRecord(this.pointId);
    },
  },
};
</script>

<style scoped lang='less'>
.el-date-editor {
  width: 113px;
  margin-top: 5px;
  margin-bottom: 35px;
}
/deep/ .el-timeline-item__tail {
  border-left: 1px dashed #409eff;
}
/deep/ .el-timeline-item__content {
  font-size: 18px;
  font-weight: bold;
  position: relative;
}
/deep/ .el-timeline-item__timestamp {
  font-size: 14px;
  color: #999;
}
/deep/ .el-timeline-item {
  padding-bottom: 95px;
}
/deep/ .el-timeline-item__wrapper {
  top: -15px !important;
}
.record_item {
  position: absolute;
  top: -10px;
  left: 120px;
  font-weight: lighter;
  div span:first-child {
    font-size: 16px;
    color: #666;
    margin-right: 20px;
  }
  div span:last-child {
    font-size: 14px;
    color: #666;
  }
  p {
    font-size: 14px;
    color: #666;
    margin-top: 5px;
  }
}
.scrollBar {
  height: 600px;
  padding-top: 30px;
  overflow-y: auto;
}
.noData {
  text-align: center;
}
</style>
